import { Injectable } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import type { Option } from '@comparit/core';
import { map, startWith } from 'rxjs';
import type { Beschaeftigungsart, Geschlecht, Step7FormInput } from '../../interfaces';
import { BaseForm } from '../base-form';
import { Step7Form } from './modules/step7-form';
import { beschaeftigungsartOptions } from './options/beschaeftigungsart-options';
import { geschlechtOptions } from './options/geschlecht-options';

export interface ZurPersonStepForms {
  step7: Step7FormInput;
}

@Injectable({ providedIn: 'root' })
export class ZurPersonFormService {
  readonly geschlechtOptions: Option<Geschlecht>[] = geschlechtOptions;
  readonly beschaeftigungsartOptions: Option<Beschaeftigungsart>[] = beschaeftigungsartOptions;
}

export class ZurPersonFormCreator extends BaseForm {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: ZurPersonStepForms | null
  ) {
    super();
  }

  public step7Form = new Step7Form(this.fb, this.defaultValue?.step7);

  override stepsCtrls = {
    step7: this.step7Form.fg,
  };

  _fg = this.fb.group(this.stepsCtrls);
  fgDefaultValue = this._fg.getRawValue();

  fgValueChanges$ = this._fg.valueChanges.pipe(
    map(() => this._fg.getRawValue() as ZurPersonStepForms)
  );

  fgValue$ = this._fg.valueChanges.pipe(
    startWith(null),
    map(() => this._fg.getRawValue() as ZurPersonStepForms)
  );
}
